import isLoaded from './is-loaded';

export default {
  isLoaded,
};
